import styled from 'styled-components';

import { PrimaryButton } from 'components/Button';
import { IconContainer } from 'components/Button/Button.styled';
import { breakpoints } from 'theme';

type Props = {
  className?: string;
  iconOnly: boolean;
  qaId: string;
};

export const SearchButtonWrapper = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
`;

export const SearchButtonTextContainer = styled.span<{ $hide: boolean }>`
  display: none;
  margin-left: 7px;
  margin-right: 4px;

  @media (min-width: ${breakpoints[1]}) {
    display: ${(props) => (props.$hide ? 'none' : 'block')};
  }
`;

export const PostSearchButton = styled(
  ({ className, iconOnly, qaId }: Props) => (
    <PrimaryButton
      aria-label="Search"
      className={className}
      iconName="search"
      type="submit"
      data-qa-id={qaId}
      size="large"
    >
      <SearchButtonTextContainer $hide={iconOnly}>
        {getText('Search')}
      </SearchButtonTextContainer>
    </PrimaryButton>
  ),
)<{ iconOnly: boolean }>`
  gap: 0;

  @media (max-width: ${breakpoints[1]}) {
    padding-left: 15px !important;
    padding-right: 15px !important;
  }

  ${IconContainer} {
    margin: 0 -2px;
  }

  @media (min-width: ${breakpoints[1]}) {
    gap: ${(props) => (props.iconOnly ? 0 : '8px')};
  }
`;
